import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ChecklistCategoryIndicator } from '../classes/checklistCategoryIndicator';
import config from "../config.json";

@Injectable({
    providedIn: 'root'
})
export class ChecklistCategoryIndicatorService {
    API_CHECKLIST_CATEGORY_INDICATOR_URL = config.serverAddress + ':' + config.serverPort + '/checklist-category-indicator/';

    constructor(private http: HttpClient) { }
    getAll() {
        return this.http.get(this.API_CHECKLIST_CATEGORY_INDICATOR_URL + 'all');
    }
    getByID(id: string) {
        return this.http.get(this.API_CHECKLIST_CATEGORY_INDICATOR_URL + id);
    }
    getByContractID(idContract: string | null) {
        return this.http.get(this.API_CHECKLIST_CATEGORY_INDICATOR_URL + 'contract/' + idContract);
    }
    create(checklistCategoryIndicator: ChecklistCategoryIndicator) {
        return this.http.post(this.API_CHECKLIST_CATEGORY_INDICATOR_URL + 'create', checklistCategoryIndicator);
    }
    update(checklistCategoryIndicator: ChecklistCategoryIndicator) {
        return this.http.put(this.API_CHECKLIST_CATEGORY_INDICATOR_URL + 'update', checklistCategoryIndicator);
    }
    delete(id: number) {
        return this.http.delete(this.API_CHECKLIST_CATEGORY_INDICATOR_URL + 'delete/' + id);
    }
}